// import { computed, onUnmounted, ref } from 'vue'

// export function useAutoRefresh(callback: () => Promise<void>, delay: number) {
//   const timer = ref<number | null>(null)

//   const startRefresh = () => {
//     stopRefresh() // предотвращаем дублирование
//     const run = async () => {
//       await callback()
//       timer.value = window.setTimeout(run, delay)
//     }
//     timer.value = window.setTimeout(run, delay)
//   }

//   const stopRefresh = () => {
//     if (timer.value) {
//       clearTimeout(timer.value)
//       timer.value = null
//     }
//   }

//   onUnmounted(stopRefresh)

//   return { startRefresh, stopRefresh, isRefreshActive: computed(() => timer.value !== null) }
// }

import { computed, onUnmounted, ref, onScopeDispose } from 'vue'

export function useAutoRefresh(callback: () => Promise<void> | void, delay: number) {
  const timer = ref<number | null>(null)
  const isActive = ref(false)

  const startRefresh = () => {
    stopRefresh()
    isActive.value = true

    const execute = async () => {
      if (!isActive.value) return

      try {
        await callback()
      } catch (error) {
        console.error('Auto refresh error:', error)
        stopRefresh()
      }

      if (isActive.value) {
        timer.value = window.setTimeout(execute, delay)
      }
    }

    timer.value = window.setTimeout(execute, delay)
  }

  const stopRefresh = () => {
    if (timer.value) {
      clearTimeout(timer.value)
      timer.value = null
    }
    isActive.value = false
  }

  // Лучше использовать onScopeDispose для совместимости с эффектами scope
  onScopeDispose(stopRefresh)
  // Или оставить onUnmounted для совместимости
  onUnmounted(stopRefresh)

  return {
    startRefresh,
    stopRefresh,
    isRefreshActive: computed(() => timer.value !== null),
  }
}
